// Single source of truth for the code/monospace font used across the app
// (API keys, code samples, Monaco editors, jq builder, `font-mono` Tailwind class).
// To try a different font, change MONO_FONT_NAME (must be a Google Fonts family)
// and, if needed, MONO_FONT_WEIGHTS — everything else derives from these.
export const MONO_FONT_NAME = 'Red Hat Mono';
export const MONO_FONT_WEIGHTS = [400, 500, 700];
export const MONO_FONT_FAMILY = `'${MONO_FONT_NAME}', ui-monospace, Menlo, Monaco, Consolas, monospace`;

// Loads the font from Google Fonts and exposes it as the --font-mono CSS
// variable (consumed by tailwind.config.js `fontFamily.mono` and index.css).
// Monaco editors can't resolve CSS variables (they measure fonts via canvas),
// so they import MONO_FONT_FAMILY directly.
const MONO_FONT_LINK_ID = 'mono-font-stylesheet';

export const loadMonoFont = () => {
  if (
    typeof document === 'undefined' ||
    document.getElementById(MONO_FONT_LINK_ID)
  )
    return;
  const link = document.createElement('link');
  link.id = MONO_FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${MONO_FONT_NAME.replace(/ /g, '+')}:wght@${MONO_FONT_WEIGHTS.join(';')}&display=swap`;
  document.head.appendChild(link);
  document.documentElement.style.setProperty('--font-mono', MONO_FONT_FAMILY);
};
